/** * Created by lobin on 2019/2/13. */
<template>
  <div class="baseInfo-add-box">
    <div style="height: 40px;"></div>
    <div class="baseInfo-add">
      <h2>欢迎来到蓉e聘-C端</h2>
      <p style="margin-bottom: 20px;">请填写您的基本信息，快速创建在线简历</p>
      <el-form
        :model="baseInfo"
        :rules="baseInfoRules"
        ref="baseInfo"
        label-width="100px"
        class="myresume-form"
        size="small"
      
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="姓名" prop="jobSeekerName"
              ><el-input
                v-model="baseInfo.jobSeekerName"
                placeholder="请输入姓名"
              ></el-input
            ></el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="性别" prop="gender">
              <el-select v-model="baseInfo.gender" placeholder="请选择" clearable>
                <el-option
                  v-for="item in gender"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="生日" prop="birthday">
              <el-date-picker
                type="month"
                placeholder="选择日期"
                v-model="baseInfo.birthday"
                :picker-options="pickerOptionsEnd"
                style="width: 100%;"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12"
            ><el-form-item label="手机号" prop="phone"
              ><el-input
                v-model="baseInfo.phone"
                placeholder="请输入手机号"
              ></el-input></el-form-item
          ></el-col>
          <el-col :span="12"
            ><el-form-item label="微信号" prop="jobSeekerWechatId"
              ><el-input
                v-model="baseInfo.jobSeekerWechatId"
                placeholder="请输入微信号"
              ></el-input></el-form-item
          ></el-col>
          <el-col :span="12"
            ><el-form-item label="邮箱" prop="email"
              ><el-input
                v-model="baseInfo.email"
                placeholder="请输入邮箱"
              ></el-input></el-form-item
          ></el-col>

          <el-col :span="12">
            <el-form-item label="最高学历" prop="qualificationsType">
              <el-select
                v-model="baseInfo.qualificationsType"
                placeholder="请选择最高学历"
              >
                <el-option
                  :label="item.name"
                  v-for="item in qualificationsType"
                  :key="item.code"
                  :value="item.code"
                  >{{ item.name }}</el-option
                >
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="毕业学校" prop="graduateSchool">
              <el-input
                v-model="baseInfo.graduateSchool"
                placeholder="请输入毕业学校"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="专   业" prop="majorSubjects">
              <el-input
                v-model="baseInfo.majorSubjects"
                placeholder="请输入最高学历所学专业"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="毕业时间" prop="graduateDate">
              <el-date-picker
                type="month"
                placeholder="选择日期"
                v-model="baseInfo.graduateDate"
                :picker-options="pickerOptionsEnd"
                style="width: 100%;"
                value-format="yyyy-MM"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="当前公司" prop="currentCompany"
              ><el-input
                v-model="baseInfo.currentCompany"
                placeholder="请输入当前就职公司"
              ></el-input
            ></el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="当前职位" prop="positionName"
              ><el-input
                v-model="baseInfo.positionName"
                placeholder="请输入当前职位"
              ></el-input
            ></el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所在城市" prop="currentAreaId"
              ><el-input
                v-model="baseInfo.currentAreaId"
                placeholder="请输入当前所在城市"
              ></el-input
            ></el-form-item>
          </el-col>
          <el-col :span="24" style="text-align: center"><el-button type="primary" @click="modifyBaseInfo">保存</el-button></el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>

<script type="text/babel">
import { mapGetters, mapActions } from "vuex";
import { regular } from "../../libs/utilts";
export default {
  data() {
    return {
      baseInfo: {}
    };
  },
  computed: {
    ...mapGetters([
      "gender",
      "qualificationsType",
      "currentState",
      "positionType",
      "qualificationsType",
      "salaryRange"
    ]),
    baseInfoRules() {
      // 验证手机号码
      const phoneReg = regular.phone;
      const validatorPhone = async (rule, value, callback) => {
        if (!value) {
          return callback(new Error("手机号不能为空!!"));
        }
        if (!phoneReg.test(value)) {
          return callback(new Error("电话号码不符合规则"));
        } else {
          callback();
        }
      };
      return {
        jobSeekerName: [
          { required: true, trigger: "blur", message: "用户姓名必填" }
        ],
        gender: [{ required: true, trigger: "change", message: "性别必填" }],
        phone: [
          { required: true, trigger: "change", validator: validatorPhone }
        ],
        qualificationsType: [
          { required: true, trigger: "change", message: "学历必填" }
        ],
        birthday: [{ required: true, trigger: "blur", message: "生日必填" }],
        currentAreaId: [
          { required: true, trigger: "blur", message: "所在城市必填" }
        ],
        jobSeekerWechatId: [
          { required: true, trigger: "blur", message: "微信号" }
        ],
        email: [{ required: true, trigger: "blur", message: "邮箱必填" }],
        arriveDate: [
          { required: true, trigger: "blur", message: "到岗时间必填" }
        ],
        majorSubjects: [{ required: true, trigger: "blur", message: "专业必填" }],
        expectedCity: [
          { required: true, trigger: "blur", message: "期望城市必填" }
        ],
        positionName: [
          { required: true, trigger: "blur", message: "目前职位必填" }
        ],
        currentSalary: [
          { required: true, trigger: "blur", message: "目前薪水必填" }
        ],
        expectedPositionNames: [
          { required: true, trigger: "blur", message: "期望职位必填" }
        ],
        graduateSchool: [
          { required: true, trigger: "blur", message: "毕业学校必填" }
        ],
        currentCompany: [
          { required: true, trigger: "blur", message: "当前公司必填" }
        ],
        graduateDate: [
          { required: true, trigger: "blur", message: "毕业时间必填" }
        ]
      };
    },
    pickerOptionsEnd() {
      return {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;
        }
      };
    }
  },
  methods: {
    ...mapActions(["modifyUserBaseInfo", "getSelfUserInfo"]),
    async modifyBaseInfo() {
      const validate = await this.$refs["baseInfo"].validate();
      if (!validate) return;
      const res = await this.modifyUserBaseInfo(this.baseInfo);
      console.log(res);
      await this.getSelfUserInfo();
      if (res.code === 200) {
        this.$message.success("修改成功");
        this.$router.push("/myresume");
      } else {
        this.$message.error(res.message);
      }
    }
  }
};
</script>

<style lang="less" rel="stylesheet/less">
.baseInfo-add-box{
  background: linear-gradient(163deg, #51B3FA 0%, #287CF3 100%);
  height: 600px;
}
.baseInfo-add {
  width: 932px;
  background: #FFFFFF;
  box-shadow: 0px 8px 24px -4px rgba(32,100,196,0.6);
  border-radius: 24px;
  margin: 0 auto;
  padding: 20px 80px;
  box-sizing: border-box;
  h2{
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(0,0,0,0.88);
  }
  p{
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0,0,0,0.55);
    padding-top: 8px;
  }

  .el-select {
    width: 100%;
  }
}
</style>
